"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHoverEvents = setHoverEvents;
var _ramda = require("ramda");
function setHoverEvents(cfg, props) {
  if (props.onHover) {
    const lens = (0, _ramda.lensPath)(['onHover']);
    cfg.options = (0, _ramda.set)(lens, props.onHover, cfg.options);
  }
}